import React, { Component } from 'react';
import './Navbar.css';
import { AppBar, Toolbar, IconButton, Typography, Button, Menu, MenuItem } from "@material-ui/core";
import HomeIcon from '@material-ui/icons/Home';
import logo from "../../logo02.webp";
import logoAlternativo from "../../logo01.webp";
import { Link, withRouter } from 'react-router-dom';

// Códigos de evento que usan el logo alternativo
const EVENTOS_LOGO_ALTERNATIVO = ['112', '112'];

class NavBar extends Component {

    constructor(props) {
        super(props)
        this.state = {
            
        }
    }

    getLogo() {
        const eventId = this.props.match && this.props.match.params
            ? this.props.match.params.id
            : null;

        return eventId && EVENTOS_LOGO_ALTERNATIVO.includes(String(eventId))
            ? logoAlternativo
            : logo;
    }

    render() {
        return (
            
            <div className="container">
                <AppBar position="static">
                    <Toolbar>
                        <div className='logo_y_home_y_title'>
                            <div className="logo">
                                <Link to="/"><img className="logo-img" src={this.getLogo()}/></Link>
                            </div>
                            
                            <div className='homeIcon'>
                                <IconButton edge="start" color="inherit" aria-label="menu">
                                    <Link to="/"><HomeIcon className='homeIcon-icon' style={{color: "#fff"}} /></Link>
                                </IconButton>
                            </div>

                            <div className='title'>
                                <Typography variant="h6" align="center" className="title-text">
                                    TIEMPOS ONLINE
                                </Typography>
                            </div>
                        </div>

                    </Toolbar>

                </AppBar>
                
            </div>

        );
    }
}
export default withRouter(NavBar);
